var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CardPaymentSummaryHeader_1;
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Image, Text } from '@philips-internal/oswald-ui-components/lib/components';
import React, { Component } from 'react';
import { SituationType } from './card-payment-summary-type';
import './card-payment-summary-header.css';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import CanceledSVG from '../../assets/images/icons/Canceled.svg';
import ConfirmedSVG from '../../assets/images/icons/Confirmed.svg';
import CalendarSVG from '../../assets/images/icons/calendar.svg';
import TitleTranferredSVG from '../../assets/images/icons/Alternate-arrows.svg';
import WarningSVG from '../../assets/images/icons/warning.svg';
import moment from 'moment';
const statusPropMap = new Map([
    [SituationType.OPEN, { icon: CalendarSVG, label: 'patient.opened' }],
    [SituationType.PAID, { icon: ConfirmedSVG, label: 'patient.filtered-paid-status-checkbox' }],
    [SituationType.CANCELED, { icon: CanceledSVG, label: 'patient.canceled' }],
    [SituationType.TITLE_TRANSFERRED, { icon: TitleTranferredSVG, label: 'patient.transferred' }],
    [SituationType.LATE, { icon: WarningSVG, label: 'patient.late' }]
]);
let CardPaymentSummaryHeader = CardPaymentSummaryHeader_1 = class CardPaymentSummaryHeader extends Component {
    static { this.propTypes = { className: string, uuid: string, width: number }; }
    static { this.defaultProps = { width: 12 }; }
    render() {
        const { uuid, className, width = CardPaymentSummaryHeader_1.defaultProps.width, status, accountSettlementDate, accountNumber, isLatePayment, latePaymentDays } = this.props;
        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        const dateFormat = moment(accountSettlementDate).locale(localeStr).format('DD MMMM YY');
        let situationType = status;
        let textSituationType = MessageService.translate(statusPropMap.get(status)?.label || '');
        const lateDays = latePaymentDays || '';
        if (isLatePayment) {
            situationType = SituationType.LATE;
            textSituationType = MessageService.translate('patient.day-late');
        }
        const iconStatus = statusPropMap.get(situationType)?.icon || '';
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: className },
            React.createElement("div", { className: "detail-area" },
                React.createElement("div", { className: "info-content" },
                    React.createElement("h2", { className: "emphasis-info" },
                        React.createElement(Text, { bold: true, value: dateFormat })),
                    React.createElement("span", { className: "label-info" },
                        React.createElement(Text, { value: `${MessageService.translate('patient.number-abbreviation') + ' ' + accountNumber}` })))),
            React.createElement("div", { className: "detail-area" },
                React.createElement("div", { className: "info-content-status" },
                    React.createElement("div", { className: 'content-text-status' },
                        React.createElement(Text, { value: lateDays + ' ' + `${textSituationType}` })),
                    React.createElement("div", { className: 'status-icon' },
                        React.createElement(Image, { src: iconStatus, alt: '' }))))));
    }
};
CardPaymentSummaryHeader = CardPaymentSummaryHeader_1 = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardPaymentSummaryHeader);
export default CardPaymentSummaryHeader;
//# sourceMappingURL=card-payment-summary-header.js.map